import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';

class Shimbun extends Component {
  render() {
    return (
      <div className="App">
        <img className="logo" src={logo} alt="Logo" />
        <br />
        <div>Thailand's Aikido Association Publication...</div>
        <br />

        <div><Link to="/article">Shimbun1(English Version)</Link></div>
        <br />
        <div><Link to="/article">Shimbun1(Thai Version)</Link></div>
        <br />
        <div><Link to="/interview">Fukakusa Shihan Interview(English Version)</Link></div>
        <br />
        <div><Link to="/interview">Fukakusa Shihan Interview(Thai Version)</Link></div>
        <br />
        <br />

        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="New Wave Consulting Group" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default Shimbun;
